var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'full-screen': _vm.isFullScreen },attrs:{"id":"app"}},[_c('vue-extend-layouts'),_c('info-modal-sb'),_c('password-confirm-modal-sb'),_c('ConfirmModalSb'),_c('MicrophonePermission'),(_vm.showSplash)?_c('OrganisationSplash'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }